module.exports = __webpack_public_path__ + "static/media/rafa-preview.becbe2ec.png";